//
// menu structure
//
// nav - container for the menu
//   ul - top menu
//     li - link
//       a - anchor tag which when clicked opens or navigates to the link's url
//     li - submenu
//       div - shows the group label
//       ul
//          li - link
//             a - anchor tag which when clicked opens or navigates to the link's url
//          li - link
//             a - anchor tag which when clicked opens or navigates to the link's url
//

namespace Nbs.Xlr8PageTemplate.Menu {
  let menu: Navigation.MenuItem[] | undefined;
  let activeMenuItemId: string | undefined;
  let menuClickHandler: undefined | ((menuItem: Navigation.MenuItem) => boolean);

  export let isMenuVisible = true;

  export function render() {
    const menuElement = Utilities.getNbsMenuElement();

    updateVisibility();

    Utilities.replaceChildren(menuElement, [MenuHtmlBuilder.getTopMenuElement(menu)]);
    Flyout.titleCheck();
    Header.HeaderMenuButton.render();
    MenuDom.setActiveMenuItem();
  }

  export function hide() {
    isMenuVisible = false;
    updateVisibility();
  }

  export function show() {
    isMenuVisible = true;
    updateVisibility();
  }

  export function setMenuItems(newMenu?: Navigation.MenuItem[]) {
    menu = newMenu;
    Flyout.reset();
    render();
  }

  export function setMenuClickHandler(clickHandler?: ((menuItem: Navigation.MenuItem) => boolean)) {
    menuClickHandler = clickHandler;
  }

  export function clearActiveMenuItem() {
    activeMenuItemId = undefined;
    MenuDom.setActiveMenuItem();
  }

  export function setActiveMenuItem(menuItemId: string | undefined) {
    activeMenuItemId = menuItemId;
    MenuDom.setActiveMenuItem();
  }

  export function getActiveMenuItem() {
    return activeMenuItemId;
  }

  export function setBadge(menuItemId: string, value: number, type: Navigation.BadgeType) {
    setBadgeValue(menuItemId, value);
    setBadgeType(menuItemId, type);
  }

  export function setBadgeValue(menuItemId: string, value: number) {
    return MenuDom.setBadgeValue(menuItemId, value);
  }

  export function setBadgeType(menuItemId: string, type: Navigation.BadgeType) {
    return MenuDom.setBadgeType(menuItemId, type);
  }

  export function setBadgeVisibility(menuItemId: string, isVisible: boolean) {
    return MenuDom.setBadgeVisibility(menuItemId, isVisible);
  }

  export const onClick = (event: MouseEvent) => {
    return Navigation.handleClickEvent(event, menu, menuClickHandler);
  }

  export function onExpanderClick(event: MouseEvent) {
    const expanderLiElement = (event.target as HTMLElement).closest('li') as HTMLElement;
    MenuDom.toggleExpander(expanderLiElement);
    Utilities.stopEvent(event);
    return false;
  }

  export function onFlyoutClick(event: MouseEvent, menuItemId: string) {
    const menuItem = Navigation.getMenuItem(menu, menuItemId);
    Flyout.navigationClickHandler(menuItem as Navigation.Menu);
    Utilities.stopEvent(event);
    return false;
  }

  export function setMenuHeight() {
    const menuElement = Utilities.getNbsMenuElement();
    const nav = menuElement.firstChild;
    if (nav) {
      const navElement = nav as HTMLElement;
      const newHeight = window.innerHeight - Header.getHeight();
      const style = `${newHeight}px`;
      navElement.style.height = style;
    }
  }

  export function setMenuTop(){
    const menuElement = Utilities.getNbsMenuElement();
    if (menuElement) {
      const style = `${Header.getHeightForMenu()}px`;
      menuElement.style.top = style;
    }
  }

  function updateVisibility() {
    if (isMenuVisible && menu && menu.length > 0) {
      setMenuHeight();
      Utilities.addClass(document.body, 'xpt-menu-visible');
    } else {
      Utilities.removeClass(document.body, 'xpt-menu-visible');
    }
  }
}
